import {action, computed, observable, runInAction} from 'mobx';
import BasePaginationStore from '@store/Common/BasePaginationStore';
import service from '@service/index';
import fetchUrl from '@service/fetchUrl';
import {message} from 'antd';
import CustomerTypeSelect from "@ViewsDashboard/Common/CustomerTypeSelect";

class Item {
    constructor(data) {
        this.init(data);
    }

    @action
    init(data) {
        for (let attr in data) {
            this[attr] = data[attr];
        }
    }

    @observable
    id = "";

    /**
     * 昵称
     */
    @observable
    pet_name = "";

    /**
     * 用户账号
     */
    nick_name = "";

    /**
     * 推荐会员数
     */
    @observable
    user_num = "";

    /**
     * 账户余额
     */
    @observable
    balance = "";


    /**
     * 返点
     */
    @observable
    radio = 0;

    /**
     * 钱包状态
     */
    @observable
    wallet_status;

    /**
     * 是否允许发展下级
     */
    @observable
    recommended_status;

    /**
     * 是否允许发展下级
     */
    @observable
    determinedstars;

    /**
     * 上线名称
     */
    @observable
    proxy_nick_name;

    /**
     * 上线id
     */
    @observable
    proxy_id;

    /**
     * 推广码
     */
    @observable
    proxy_number;


    /**
     * 最后登录时间
     */
    @observable
    last_login_time;

    /**
     * 彩金
     */
    @observable
    mosaic_gold;

    /**
     * 注册时间
     */
    @observable
    reg_time;

    /**
     * 盈亏(总输赢)
     */
    @observable
    yingkui;

    /**
     * 总充值
     */
    @observable
    pay_money;

    @observable
    isUsed = true;
}

class PaginationStore extends BasePaginationStore {

}

/**
 * 页面头部筛选过滤器字段值
 */
class FilterStore {

    //是否初始化过
    is_init;

    search;
    type;

    @action
    setAttr({search, type}) {
        this.resetAttr();

        this.search = search;

        if (type == undefined) {
            this.type = CustomerTypeSelect.getTypeId(CustomerTypeSelect.TYPE_USER_ALL);
        } else {
            this.type = type;
        }

        this.is_init = true;
    }

    getAttr() {
        return {
            search: this.search,
            type: this.type,
        }
    }

    setDefault() {
        this.resetAttr();
        this.type = 1;
        this.search = '';
        this.is_init = true;
    }

    @action
    resetAttr() {
        this.search = undefined;
        this.type = undefined;
        this.is_init = undefined;
    }
}

let filter_store = new FilterStore();

class ItemStore {

    static Type_Normal = '0';
    static Type_Proxy = '1';

    constructor(pagination) {
        this.init(pagination);
    }

    @action
    init(pagination) {
        this.pagination_store = pagination;
    }

    @observable
    item_map = new Map();

    @observable
    pagination_store;

    @observable
    new_num;

    @observable
    total;

    @observable
    totalmem;

    @observable
    currentUserId = '';

    @observable
    currentType = '';

    /**
     * item 数组列表
     */
    @computed
    get item_array() {
        let res = [];
        this.item_map.forEach((values, key) => {
            res.push(values);
        });
        return res;
    }

    reloadDatas(filter) {
        this.item_map.clear();
        this.new_money = 0;
        this.pagination_store.clear();

        if (filter == undefined) {
            if (filter_store.is_init == undefined) {
                filter_store.setDefault()
            }
        } else {
            filter_store.setAttr(filter);
        }

        this.searchByFilter();
    }

    /**
     * 根据条件搜索item
     * @param {*} page_opts
     */
    async searchByFilter(page_opts) {

        let page_option = {
            page: this.pagination_store.page_cur,
            page_size: this.pagination_store.page_size,
            ...filter_store.getAttr(),
            ...page_opts
        }

        let res = await this._getItemArray(page_option);
        return res;

    }

    /**
     * 获取item 列表
     */
    async _getItemArray(page_option = {}) {
        let url = fetchUrl.admin.proxyUserList;
        let res = await service.fetchData({
            path: url,
            params: {
                id: this.currentUserId,
                ...page_option
            }
        });
        service.responseHandle({
            res: res,
            success_handle: (res) => {
                runInAction(() => {

                    this.item_map.clear();

                    res.data.data.forEach((item, index) => {
                        this.item_map.set(item.id, new Item(item));
                    });
                    this.pagination_store.setAttr(res.data.page);
                    this.new_num = res.data.new_num;
                    this.total = res.data.total;
                })
            },
            fail_handle: (res) => {
                message.error(res.error.error_data, 3);
                this.pagination_store.clear();
                filter_store.resetAttr();
                this.item_map.clear();
            }
        })
        return res;
    }

    /**
     * 提升为代理
     * @param {Item} item item
     */
    async updateToAgent(item) {
        let url = fetchUrl.agent.proxyConf;
        let res = await service.fetchData({
            path: url,
            params: {
                id: item.id,
                radio: item.radio
            }
        });
        return res;
    }

    /**
     * 更改是否允许登陆
     * @param {Item} item
     */
    async changeLoginStatus(item, value) {
        let url = fetchUrl.agent.proxyConf;
        let res = await service.fetchData({
            path: url,
            params: {
                id: item.id,
                type: 1,
                robot_stauts: value
            }
        });
        return res;
    }

    async changegetProxyEnable(item, value) {
        let url = fetchUrl.agent.getProxyEnable;
        let res = await service.fetchData({
            path: url,
            params: {
                id: item.id,
                is_routine: value
            }
        });
        return res;
    }
}

let pagination_store = new PaginationStore();
let item_store = new ItemStore(pagination_store);

export {
    pagination_store,
    filter_store,
    ItemStore
}
export default item_store;



// WEBPACK FOOTER //
// ./src/Store/User/UserList/UserStore.js